<template>
  <div class="content_nodate">
    <el-empty :image="img" :image-size="223" description="暂无数据" />
  </div>
</template>
<script>
var img = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/stateImg/nodata_pc.png'
export default {
  data() {
    return {
      img: img
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/index.scss';
.content_nodate{
  width: 100%;
  height: 100%;
  background: $color_white;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
